import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import nbNO from "./locales/nb-NO.json";
import en from "./locales/en.json";
import svSE from "./locales/sv-SE.json";
import daDK from "./locales/da-DK.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import pl from "./locales/pl.json";
import it from "./locales/it.json";
import nl from "./locales/nl.json";

export const LANGUAGES = [
  { code: "nb-NO", label: "Norsk", flag: "🇳🇴", aliases: ["nb"] },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "sv-SE", label: "Svenska", flag: "🇸🇪", aliases: ["sv"] },
  { code: "da-DK", label: "Dansk", flag: "🇩🇰", aliases: ["da"] },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "pl", label: "Polski", flag: "🇵🇱" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
];

export const SUPPORTED_LANGUAGES = LANGUAGES.map((l) => l.code);

export const LANGUAGE_LABELS = Object.fromEntries(
  LANGUAGES.map((l) => [l.code, l.label]),
);

export const LANGUAGE_FLAGS = Object.fromEntries(
  LANGUAGES.map((l) => [l.code, l.flag]),
);

const RESOURCES_BY_CODE = {
  "nb-NO": nbNO,
  en,
  "sv-SE": svSE,
  "da-DK": daDK,
  de,
  fr,
  es,
  pl,
  it,
  nl,
};

const resources = {};
const detectorWhitelist = [];
for (const lang of LANGUAGES) {
  const data = RESOURCES_BY_CODE[lang.code];
  resources[lang.code] = { translation: data };
  detectorWhitelist.push(lang.code);
  for (const alias of lang.aliases || []) {
    resources[alias] = { translation: data };
    detectorWhitelist.push(alias);
  }
}

const LEGACY_LANGUAGE_MAP = { norsk: "nb-NO", english: "en" };
const stored =
  typeof localStorage !== "undefined" && localStorage.getItem("language");
if (stored && LEGACY_LANGUAGE_MAP[stored]) {
  localStorage.setItem("language", LEGACY_LANGUAGE_MAP[stored]);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: detectorWhitelist,
    fallbackLng: "en",
    nonExplicitSupportedLngs: true,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "language",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
